<template>
  <NarrowContainer class="mb-20 px-4 @md:px-0" data-testid="wishlist-layout">
    <HeaderWithLink
      v-if="withHeader && title"
      :heading="title"
      :label-desktop="t('common.actions.back')"
      :label-mobile="t('common.actions.back')"
    />

    <div
      v-if="products.length > 0"
      :class="{ 'pointer-events-none opacity-50': loading }"
      data-testid="wishlist-page-content"
    >
      <SfLoaderCircular v-if="loading" class="absolute left-0 right-0 top-1/3 mx-auto z-max" size="2xl" />
      <section
        class="grid grid-cols-1 @2xs:grid-cols-2 gap-4 @md:gap-6 @md:grid-cols-2 @lg:grid-cols-3 @3xl:grid-cols-4 mb-10 @md:mb-5"
        data-testid="wishlist-grid"
      >
        <NuxtLazyHydrate v-for="(product, index) in products" :key="productGetters.getId(product)" when-visible>
          <UiProductCard :product="product" is-from-wishlist :index="index">
            <template #wishlistButton>
              <WishlistButton discard square class="absolute top-0 right-0 mr-2 mb-2 bg-white" :product="product" />
            </template>
          </UiProductCard>
        </NuxtLazyHydrate>
      </section>
    </div>

    <div
      v-else
      class="flex items-center justify-center flex-col py-24"
      :class="{ 'pointer-events-none opacity-50': loading }"
      data-testid="wishlist-page-content"
    >
      <SfLoaderCircular v-if="loading" class="absolute z-max" size="2xl" />
      <h2 data-testid="empty-wishlist-text" class="typography-headline-3 font-bold">
        {{ t('cart.emptyWishlist') }}
      </h2>
    </div>
    <div v-if="products.length > 0" class="mt-4 mb-4 typography-text-xs flex gap-1">
      <span>{{ t('common.labels.asterisk') }}</span>
      <span v-if="showNetPrices">{{ t('product.priceExclVAT') }}</span>
      <span v-else>{{ t('product.priceInclVAT') }}</span>
      <i18n-t keypath="shipping.excludedLabel" scope="global">
        <template #shipping>
          <UiLink
            :href="localePath(paths.shipping)"
            target="_blank"
            class="focus:outline focus:outline-offset-2 focus:outline-2 outline-secondary-600 rounded"
          >
            {{ t('common.labels.delivery') }}
          </UiLink>
        </template>
      </i18n-t>
    </div>
  </NarrowContainer>
</template>

<script setup lang="ts">
import { productGetters } from '@plentymarkets/shop-api';
import { SfLoaderCircular } from '@storefront-ui/vue';
import type { WishlistPageContentProps } from '~/components/WishlistPageContent/types';
import { paths } from '~/utils/paths';

const { showNetPrices } = useCart();
const localePath = useLocalePath();

const { withHeader = true } = defineProps<WishlistPageContentProps>();
const { fetchWishlist, data: products, loading } = useWishlist();

fetchWishlist();
</script>
